import { Injectable } from '@angular/core';
import * as localforage from 'localforage';

@Injectable({
    providedIn: 'root'
})
export class KeyValueStoreService {

    constructor() {
        localforage.config({
            driver: [
                localforage.INDEXEDDB,
                localforage.LOCALSTORAGE
            ],
            name: 'yaanimailStorage'
        });
    }

    createTable(dbName: string, tableName: string): LocalForage {
        return localforage.createInstance({
            name: dbName,
            storeName: tableName
        });
    }

    get(table: LocalForage, key: string): Promise<any> {
        return table.getItem(key);
    }

    set(table: LocalForage, key: string, value: any): Promise<any> {
        return table.setItem(key, value);
    }

    remove(table: LocalForage, key: string): Promise<void> {
        return table.removeItem(key);
    }

    deleteAll(table: LocalForage): Promise<void> {
        return table.clear();
    }

    removeAllStores(): Promise<void> {
        return localforage.clear();
    }

    listKeys(table: LocalForage): Promise<string[]> {
        return table.keys();
    }

    removeInstance(dbName: string, tableName: string): Promise<void> {
        return localforage.dropInstance({ name: dbName, storeName: tableName });
    }
}
